import { render, staticRenderFns } from "./CmgIngredientsBanner.vue?vue&type=template&id=21419182&scoped=true&lang=pug"
import script from "./cmg-ingredients-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ingredients-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIngredientsBanner.vue?vue&type=style&index=0&id=21419182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21419182",
  null
  
)

export default component.exports